import { render } from "./MobileHeader.vue?vue&type=template&id=38ad48a1&scoped=true"
import script from "./MobileHeader.vue?vue&type=script&lang=js"
export * from "./MobileHeader.vue?vue&type=script&lang=js"

import "./MobileHeader.vue?vue&type=style&index=0&id=38ad48a1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ad48a1"]])

export default __exports__